<template>
  <div class="user">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'User'
}
</script>
